import { Vertical } from '@/types/verticals'

export const API_PATHS = Object.freeze({
  LINES: '/v1/markups/lines',
  SHAPES: '/v1/markups/shapes',
  WAYPOINTS: '/v1/markups/waypoints',
  TRACKS: '/v1/markups/tracks',
  PARCELS: '/v1/markups/parcels',
})

export const FOCUSED_MARKUP_EDIT_MODES = [
  'editing',
  'click-drawing',
  'freehand-drawing',
  'trimming',
  'connect',
  'split',
  'route-create',
]

export const FOCUSED_MARKUP_VIEW_MODES = [
  'route-view',
  'line-view',
  'shape-view',
]

export const FOCUSED_MARKUP_MODES = [
  ...FOCUSED_MARKUP_EDIT_MODES,
  ...FOCUSED_MARKUP_VIEW_MODES,
]

export const MARKUP_LAYER_TYPES = Object.freeze({
  LINE: 'LineString',
  AREA: 'Polygon',
  WAYPOINT: 'Point',
  ROUTE: 'LineString',
})

export const SIMPLIFY_TOLERANCE = 0.00001

export const DEFAULT_MARKUP_NAME_REGEX =
  /^(Waypoint|My Location|Marker|Line|Area|Track|Route|Land Area) \d+(\/|-)\d+(\/|-)\d+(, | )\d+:\d+.*/

/** Defines constant values to use for referring to specific markup types */
export const MARKUP_CONTENT_TYPES = Object.freeze({
  ALL: 'all',
  WAYPOINT: 'waypoint',
  TRACK: 'track',
  AREA: 'shape',
  LINE: 'line',
  ROUTE: 'route',
})

export type MarkupContentType =
  (typeof MARKUP_CONTENT_TYPES)[keyof typeof MARKUP_CONTENT_TYPES]

/**
 * Maps My Content route (e.g., 'areas' from /map/content/areas) to the corresponding markup type (e.g., 'shape').
 */
export const URL_ROUTE_TO_MARKUP: Record<string, MarkupContentType> = {
  waypoints: MARKUP_CONTENT_TYPES.WAYPOINT,
  tracks: MARKUP_CONTENT_TYPES.TRACK,
  areas: MARKUP_CONTENT_TYPES.AREA,
  lines: MARKUP_CONTENT_TYPES.LINE,
  routes: MARKUP_CONTENT_TYPES.ROUTE,
}

/**
 * Maps markup type to user-friendly label (singular)
 */
export const MARKUP_TYPE_LABELS: Record<string, string> = {
  waypoint: 'Waypoint',
  line: 'Line',
  track: 'Track',
  shape: 'Area',
  route: 'Route',
}

/**
 * Maps markup type to user-friendly label (plural)
 */
export const MARKUP_TYPE_LABELS_PLURAL: Record<string, string> = {
  waypoint: 'Waypoints',
  line: 'Lines',
  track: 'Tracks',
  shape: 'Areas',
  route: 'Routes',
}

/**
 *  Any permissions that can be returned for a markup
 */
export const MARKUP_PERMISSIONS = Object.freeze({
  COPY: 'markup.copy',
})

/**
 * The order of markup content types to display in each app
 */
export const MARKUP_TYPE_ORDER_BY_APP: Partial<
  Record<Vertical, MarkupContentType[]>
> = Object.freeze({
  [Vertical.Fish]: [
    MARKUP_CONTENT_TYPES.ALL,
    MARKUP_CONTENT_TYPES.WAYPOINT,
    MARKUP_CONTENT_TYPES.TRACK,
    MARKUP_CONTENT_TYPES.AREA,
    MARKUP_CONTENT_TYPES.LINE,
    MARKUP_CONTENT_TYPES.ROUTE,
  ],
})
